<script setup>
import Spinner from 'shared/components/Spinner.vue';

const emit = defineEmits(['download']);
defineProps({
  header: {
    type: String,
    default: '',
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  loadingMessage: {
    type: String,
    default: '',
  },
  showDownload: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    class="flex flex-col m-0.5 px-6 py-5 rounded-xl flex-grow text-n-slate-12 shadow outline-1 outline outline-n-container bg-n-solid-2 min-h-[10rem]"
  >
    <div
      class="card-header flex w-full mb-4 justify-between items-start"
    >
      <slot name="header">
        <div class="sz-mc-title-col">
          <span class="sz-mc-title">{{ header }}</span>
          <span class="sz-mc-subtitle">Atualizado agora</span>
        </div>
        <div class="sz-mc-controls">
          <slot name="control" />
          <button v-if="showDownload" class="sz-mc-download-btn" title="Exportar" @click="emit('download')">
            <svg width="20" height="20" viewBox="0 0 32 32" fill="none">
              <path d="M15.5578 17.6922C15.6159 17.7503 15.6848 17.7964 15.7607 17.8279C15.8365 17.8593 15.9179 17.8755 16 17.8755C16.0821 17.8755 16.1635 17.8593 16.2393 17.8279C16.3152 17.7964 16.3841 17.7503 16.4422 17.6922L19.5672 14.5672C19.6253 14.5091 19.6713 14.4402 19.7027 14.3643C19.7342 14.2884 19.7503 14.2071 19.7503 14.125C19.7503 14.0429 19.7342 13.9616 19.7027 13.8857C19.6713 13.8098 19.6253 13.7409 19.5672 13.6828C19.5091 13.6247 19.4402 13.5787 19.3643 13.5473C19.2884 13.5158 19.2071 13.4997 19.125 13.4997C19.0429 13.4997 18.9616 13.5158 18.8857 13.5473C18.8098 13.5787 18.7409 13.6247 18.6828 13.6828L16.625 15.7414V8.5C16.625 8.33424 16.5592 8.17527 16.4419 8.05806C16.3247 7.94085 16.1658 7.875 16 7.875C15.8342 7.875 15.6753 7.94085 15.5581 8.05806C15.4408 8.17527 15.375 8.33424 15.375 8.5V15.7414L13.3172 13.6828C13.1999 13.5655 13.0409 13.4997 12.875 13.4997C12.7091 13.4997 12.5501 13.5655 12.4328 13.6828C12.3155 13.8001 12.2497 13.9591 12.2497 14.125C12.2497 14.2909 12.3155 14.4499 12.4328 14.5672L15.5578 17.6922Z" fill="currentColor"/>
              <path d="M23.5 17.25V22.25C23.5 22.4158 23.4342 22.5747 23.3169 22.6919C23.1997 22.8092 23.0408 22.875 22.875 22.875H9.125C8.95924 22.875 8.80027 22.8092 8.68306 22.6919C8.56585 22.5747 8.5 22.4158 8.5 22.25V17.25C8.5 17.0842 8.56585 16.9253 8.68306 16.8081C8.80027 16.6908 8.95924 16.625 9.125 16.625C9.29076 16.625 9.44973 16.6908 9.56694 16.8081C9.68415 16.9253 9.75 17.0842 9.75 17.25V21.625H22.25V17.25C22.25 17.0842 22.3158 16.9253 22.4331 16.8081C22.5503 16.6908 22.7092 16.625 22.875 16.625C23.0408 16.625 23.1997 16.6908 23.3169 16.8081C23.4342 16.9253 23.5 17.0842 23.5 17.25Z" fill="currentColor"/>
            </svg>
          </button>
        </div>
      </slot>
    </div>
    <div
      v-if="!isLoading"
      class="card-body max-w-full w-full ml-auto mr-auto justify-between flex"
    >
      <slot />
    </div>
    <div v-else-if="isLoading" class="sz-skeleton-wrap">
      <div class="sz-skeleton-row">
        <div class="sz-skeleton sz-skeleton-stat" />
        <div class="sz-skeleton sz-skeleton-stat" />
        <div class="sz-skeleton sz-skeleton-stat" />
        <div class="sz-skeleton sz-skeleton-stat" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.sz-mc-title-col { display: flex; flex-direction: column; }
.sz-mc-title { font-family: 'Inter', sans-serif; font-weight: 600; font-size: 16px; line-height: 24px; color: #000; }
.sz-mc-subtitle { font-family: 'Inter', sans-serif; font-weight: 400; font-size: 12px; line-height: 20px; color: #525252; }
.sz-mc-controls { display: flex; align-items: center; gap: 8px; }
.sz-mc-download-btn { display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; background: none; border: 1.5px solid #D4D4D4; border-radius: 8px; cursor: pointer; color: #000; padding: 0; flex-shrink: 0; }
.sz-mc-download-btn:hover { background: #F3F4F6; }
</style>

<style>
/* Dark mode */
.dark .sz-mc-title { color: #EDEEEF; }
.dark .sz-mc-subtitle { color: #9CA3AF; }
.dark .sz-mc-download-btn { color: #D4D4D4; border-color: #363840; }
.dark .sz-mc-download-btn:hover { background: #363840; }
</style>
